import { EMPLOYEE_TYPES } from "features/planner/planner.constants";
import { generatePath } from "react-router-dom";

export const toEmployeeCard = (employeeCardId, subpage) =>
  subpage
    ? `${generatePath("/employee/:employeeCardId", {
        employeeCardId,
      })}/${subpage}`
    : generatePath("/employee/:employeeCardId", { employeeCardId });

export const toSubContractorCard = (employeeCardId, subpage) =>
  subpage
    ? `${generatePath("/sub-contractor/:employeeCardId", {
        employeeCardId,
      })}/${subpage}`
    : generatePath("/sub-contractor/:employeeCardId", {
        employeeCardId,
      });

export const toCard = (card, subpage = "") =>
  card.getIn(["employee", "type"]) === EMPLOYEE_TYPES.EMPLOYEE
    ? toEmployeeCard(card.get("id"), subpage)
    : toSubContractorCard(card.get("id"), subpage);

export const toHeliReport = groupId =>
  generatePath("/reports/helicopter-booking/:groupId?", { groupId });
